import { configureStore } from '@reduxjs/toolkit'; // Redux Toolkit
import { createBrowserHistory } from 'history'; // Correct import from the history package
import rootReducer from './reducers';

// Create the history object
export const history = createBrowserHistory();

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production', // Enable Redux DevTools in development
});

export default store;
